var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCarParking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M150,0c-68.457,0 -123.945,55.493 -123.945,123.945c-0,94.132 123.945,176.055 123.945,176.055c0,0 123.945,-81.923 123.945,-176.055c0,-68.452 -55.488,-123.945 -123.945,-123.945Zm0,220.278c-53.203,-0 -96.328,-43.125 -96.328,-96.333c-0,-53.203 43.125,-96.333 96.328,-96.333c53.203,0 96.338,43.13 96.338,96.333c0,53.209 -43.135,96.333 -96.338,96.333Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.487,69.023l-43.12,-0.077l-0,115l22.998,-0l-0,-28.838l20.122,-0c23.774,-0 43.047,-19.268 43.047,-43.037c-0,-23.78 -19.272,-43.048 -43.047,-43.048Zm14.176,57.217c-3.785,3.789 -8.819,5.87 -14.175,5.87l-20.123,-0l0,-40.127l20.083,0.038l0.039,0c5.357,0 10.39,2.081 14.175,5.87c3.789,3.789 5.873,8.818 5.873,14.18c0.001,5.351 -2.084,10.38 -5.872,14.169Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarParking);
export default __webpack_public_path__ + "static/media/car_parking.75d295dd.svg";
export { ForwardRef as ReactComponent };